import {
  DashBoardIcon,
  UserIcon,
  MasterIcon,
  PhotographerIcon,
  KeywordIcon,
  ImageIcon,
  OrderIcon,
  LogsIcon,
  CRMIcon,
  ReportsIcon,
  Settings,
  Send,
  CategoryIcon,
  CompanyIcon,
  StarIndustriesIcon,
  VideoCameraBack,
  People,
} from '../Asset/svg';
import { getItemFromStorage } from '../storage/Storage';

const IconArr = [
  DashBoardIcon,
  MasterIcon,
  UserIcon,
  PhotographerIcon,
  KeywordIcon,
  ImageIcon,
  VideoCameraBack,
  OrderIcon,
  OrderIcon,
  KeywordIcon,
  Settings,
  Send,
  People,
  LogsIcon,
  CRMIcon,
  CategoryIcon,
  CompanyIcon,
  StarIndustriesIcon,
  ReportsIcon,
  UserIcon,
];

export { IconArr };
let sideMenu = [
  {
    pathName: '/dashboard',
    label: 'Dashboard',
    icon: 0,
    value: 'dashboard',
  },
  {
    pathName: '/biller',
    label: 'All Biller Party',
    icon: 2,
    value: 'biller',
  },
  {
    pathName: '/receiver',
    label: 'All Receiver Party',
    icon: 2,
    value: 'receiver',
  },
  {
    pathName: '/design',
    label: 'Designs',
    icon: 4,
    value: 'design',
  },
  {
    pathName: '/fabricIssue',
    label: 'Fabric Issue',
    icon: 18,
    value: 'fabricIssue',
  },
  {
    pathName: '/chalan',
    label: 'All Chalan',
    icon: 18,
    value: 'chalan',
  },
  {
    pathName: '/jobwork',
    label: 'Master Cutting',
    icon: 18,
    value: 'jobwork',
  },
  // {
  //   pathName: '/departments',
  //   label: 'Departments',
  //   icon: 13,
  //   value: 'departments',
  // },
];

export { sideMenu };

export const MenuList = [
  'Dashboard',
  'Master',
  'Users',
  'Contributors',
  'Keywords',
  'Images',
  'Videos',
  'Orders',
  'IRN',
  'Subscriptions',
  'Settings',
  'Contact Us',
  'Admin Users & Access',
  'Logs',
  'CRM',
  'Categories',
  'Companies',
  'Star Industries',
  'Reports',
];

export const NewMenuList = [
  { label: 'Dashboard', value: 'dashboard' },
  { label: 'Master', value: 'master' },
  { label: 'Users', value: 'users' },
  { label: 'Contributors', value: 'contributors' },
  { label: 'Keywords', value: 'keywords' },
  { label: 'Images', value: 'images' },
  { label: 'Videos', value: 'videos' },
  { label: 'Orders', value: 'orders' },
  { label: 'Subscriptions', value: 'subscriptions' },
  { label: 'IRN', value: 'irn' },
  { label: 'Settings', value: 'settings' },
  { label: 'Contact Us', value: 'contact_us' },
  { label: 'Admin Users & Access', value: 'admin_users' },
  { label: 'Logs', value: 'logs' },
  { label: 'CRM', value: 'crm' },
  { label: 'Categories', value: 'categories' },
  { label: 'Companies', value: 'companies' },
  { label: 'Star Industries', value: 'star_indutries' },
  { label: 'Reports', value: 'report' },
];
